<template>
    <div class="privacy container" id="million-bit-privacy">
        <h2>Privacy Policy</h2>
        
        
        Effective Date: July 1st, 2024

<p>
Thank you for visiting the Million Bit Homepage. Your privacy and trust are essential to us, and we are committed to maintaining the confidentiality of your personal information. This Privacy Policy describes how we collect, use, and protect your information when you interact with our website.
</p>
<h3>1. Information We Collect</h3>
<p>
We collect information to better understand our users and improve the functionality and performance of the Million Bit Homepage. Information collected includes:
</p>

<ul>
<li>Personal Information: When you voluntarily submit inquiries or interact with features on our site, we may collect personal information like your name, email address, wallet address, and contact details.</li>
<li>Device and Usage Information: This includes your IP address, browser type, device information, pages you visit, the time spent on each page, and how you interact with the site. This data helps us analyze traffic and optimize the website’s performance.</li>
<li>Cookies and Similar Technologies: We use cookies and tracking technologies to gather data on user preferences and enhance your experience on our website. You may adjust your cookie preferences through your browser settings at any time.</li>
</ul>

<h3>2. How We Use Your Information</h3>
<p>
  The information we collect is used for various purposes, including:
</p>

<ul>
  <li>Site Operations: Ensuring that our website functions smoothly, including troubleshooting and user support.</li>
  <li>Enhancement of User Experience: Personalizing your experience, understanding user preferences, and improving content and features.</li>
  <li>Communication: Responding to your inquiries and providing updates about our services, promotions, or changes to this Privacy Policy.</li>
</ul>

<h3>3. Sharing and Disclosure of Information</h3>
<p>
We do not sell or rent your personal information to third parties. We may, however, disclose your information in the following scenarios:
</p>

<ul>
<li>Legal Requirements: To comply with legal obligations, such as responding to lawful requests by public authorities.</li>
<li>Protection of Rights: To enforce our website’s policies or protect our rights, privacy, safety, and property.</li>
<li>Service Providers: We may engage third-party providers to help us operate our website. These providers are contractually obligated to handle data in a secure manner and to use it only for the specified purpose.</li>
</ul>

<h3>4. Data Security</h3>
<p>
  We implement reasonable security measures to protect your data against unauthorized access or disclosure. However, please understand that no data transmission over the internet can be completely secure, and we cannot guarantee the security of data shared with us.
</p>

<h3>5. Your Privacy Rights</h3>
<p>
Depending on your location, you may have certain rights regarding your personal information:
</p>

<ul>
  <li>Access and Correction: You can request access to your personal data and correct any inaccurate information.</li>
<li>Data Deletion: You may request the deletion of your personal data where legally applicable.</li>
<li>Objection to Processing: In certain cases, you may object to or request a restriction on processing your data.</li>
<li>To exercise any of these rights, please contact us at millionbithomepage@gmail.com.</li>
</ul>

<h3>6. Cookies and Tracking Preferences</h3>
<p>
You can control your cookie preferences through your browser. Please note that disabling certain cookies may impact your experience on the Million Bit Homepage.
</p>

<h3>7. Third-Party Websites and Links</h3>
<p>
Our website may contain links to external sites. We are not responsible for the privacy practices or content of those sites. Please review the privacy policies of those websites independently.
</p>

<h3>8. Changes to This Privacy Policy</h3>
<p>
We may update this Privacy Policy from time to time. We will post the updated policy on this page, and we encourage you to review it periodically. Any changes will be effective as of the date they are posted.
</p>

<h3>9. Contact Us</h3>
<p>
If you have any questions or concerns about this Privacy Policy, please reach out to us at:
</p>

Email: millionbithomepage@gmail.com


    </div>
  </template>
  
  <script>
  export default {
    name: 'privacy',
    data () {
      return {
        
      }
    },
    inject: ['updateAppRoute', 'appData', 'postToLambda'],
    created: function () {
      this.updateAppRoute('privacy');
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    #million-bit-privacy {
      background: #fff !important;
      padding: 20px;
      text-align: left;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/Privacy.vue?668000b1